import { BaseService } from '../base.service';

export class OwnerQuestionsService extends BaseService {
  static get resourceEndpoint() {
    return 'owners/questions';
  }
}